export const iluminacaoConfig = [
  {
    "id": "grupo01",
    "descricao": "Postes Entrada",
    "lightType": "normal",
    "onCommand": "1A10",
    "offCommand": "1A00",
    "circleNumber": 1,
    "multipleInstances": [
      {
        "x": 5.2,
        "y": 88.1,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 7.1,
        "y": 72,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 9.6,
        "y": 51.5,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 11.6,
        "y": 36.2,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 15,
        "y": 11.7,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo02",
    "descricao": "Jardim Entrada",
    "lightType": "normal",
    "onCommand": "1B10",
    "offCommand": "1B00",
    "circleNumber": 2,
    "multipleInstances": [
      {
        "x": 19,
        "y": 24.7,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 17.2,
        "y": 35.7,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 16.1,
        "y": 48,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 14.1,
        "y": 62.8,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 24,
        "y": 28.9,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo03",
    "descricao": "Floreira Externa",
    "lightType": "normal",
    "onCommand": "1C10",
    "offCommand": "1C00",
    "circleNumber": 3,
    "multipleInstances": [
      {
        "x": 26.1,
        "y": 35.5,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 27.4,
        "y": 54.7,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 24.7,
        "y": 61,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 20,
        "y": 61.7,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo04",
    "descricao": "Arandelas Muros",
    "lightType": "normal",
    "onCommand": "1D10",
    "offCommand": "1D00",
    "circleNumber": 4,
    "multipleInstances": [
      {
        "x": 26.4,
        "y": 20,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo05",
    "descricao": "Varanda Gourmet",
    "lightType": "normal",
    "onCommand": "1E10",
    "offCommand": "1E00",
    "circleNumber": 5,
    "multipleInstances": [
      {
        "x": 34,
        "y": 71.5,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 40.25,
        "y": 71.5,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo06",
    "descricao": "Varanda Coberta",
    "lightType": "normal",
    "onCommand": "1F10",
    "offCommand": "1F00",
    "circleNumber": 6,
    "multipleInstances": [
      {
        "x": 51,
        "y": 55.5,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo07",
    "descricao": "Galeria de Acesso",
    "lightType": "normal",
    "onCommand": "1G10",
    "offCommand": "1G00",
    "circleNumber": 7,
    "multipleInstances": [
      {
        "x": 34.9,
        "y": 38.8,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo08",
    "descricao": "Led Externo + Guarita",
    "lightType": "normal",
    "onCommand": "1H10",
    "offCommand": "1H00",
    "circleNumber": 8,
    "multipleInstances": [
      {
        "x": 26.7,
        "y": 29.5,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo09",
    "descricao": "Quadra Poliesportiva",
    "lightType": "normal",
    "onCommand": "1I10",
    "offCommand": "1I00",
    "circleNumber": 9,
    "multipleInstances": [
      {
        "x": 60.4,
        "y": 20.7,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 59.6,
        "y": 10.5,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo10",
    "descricao": "Piscina Térreo",
    "lightType": "normal",
    "onCommand": "1J10",
    "offCommand": "1J00",
    "circleNumber": 10,
    "multipleInstances": [
      {
        "x": 67.8,
        "y": 54.5,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo11",
    "descricao": "Postes Internos Térreo",
    "lightType": "normal",
    "onCommand": "1K10",
    "offCommand": "1K00",
    "circleNumber": 11,
    "multipleInstances": [
      {
        "x": 62.6,
        "y": 29.4,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 55.2,
        "y": 26.5,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 58.15,
        "y": 44.5,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 59.4,
        "y": 62.5,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo12",
    "descricao": "Floreira Playground",
    "lightType": "normal",
    "onCommand": "1L10",
    "offCommand": "1L00",
    "circleNumber": 12,
    "multipleInstances": [
      {
        "x": 51.15,
        "y": 71.5,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo13",
    "descricao": "Arandelas Playground",
    "lightType": "normal",
    "onCommand": "1M10",
    "offCommand": "1M00",
    "circleNumber": 13,
    "multipleInstances": [
      {
        "x": 46.7,
        "y": 71.5,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 55,
        "y": 71.5,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo14",
    "descricao": "Floreira Escada Interna",
    "lightType": "normal",
    "onCommand": "1N10",
    "offCommand": "1N00",
    "circleNumber": 14,
    "multipleInstances": [
      {
        "x": 65,
        "y": 29.3,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo15",
    "descricao": "Arandelas Piscina Térreo",
    "lightType": "normal",
    "onCommand": "1O10",
    "offCommand": "1O00",
    "circleNumber": 15,
    "multipleInstances": [
      {
        "x": 72.5,
        "y": 70.5,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 66.6,
        "y": 70.5,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo16",
    "descricao": "Floreira Pergolado Térreo",
    "lightType": "normal",
    "onCommand": "1P10",
    "offCommand": "1P00",
    "circleNumber": 16,
    "multipleInstances": [
      {
        "x": 58.8,
        "y": 71.5,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo17",
    "descricao": "Postes Garden Gourmet",
    "lightType": "normal",
    "onCommand": "1Q10",
    "offCommand": "1Q00",
    "circleNumber": 17,
    "multipleInstances": [
      {
        "x": 71.7,
        "y": 29.5,
        "width": 1.5,
        "height": 3.2
      },
      {
        "x": 80.6,
        "y": 80.5,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo18",
    "descricao": "Arandelas Garden Gourmet",
    "lightType": "normal",
    "onCommand": "1R10",
    "offCommand": "1R00",
    "circleNumber": 18,
    "multipleInstances": [
      {
        "x": 77.4,
        "y": 64.1,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo19",
    "descricao": "Floreira Garden Gourmet",
    "lightType": "normal",
    "onCommand": "1S10",
    "offCommand": "1S00",
    "circleNumber": 19,
    "multipleInstances": [
      {
        "x": 75.3,
        "y": 50.6,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo20",
    "descricao": "Arandelas Pergolado Térreo",
    "lightType": "normal",
    "onCommand": "1T10",
    "offCommand": "1T00",
    "circleNumber": 20,
    "multipleInstances": [
      {
        "x": 72.75,
        "y": 38.7,
        "width": 1.5,
        "height": 3.2
      }
    ]
  },
  {
    "id": "grupo21",
    "descricao": "Floreira Pergolado Térreo",
    "lightType": "normal",
    "onCommand": "1U10",
    "offCommand": "1U00",
    "circleNumber": 21,
    "multipleInstances": [
      {
        "x": 71.45,
        "y": 45.4,
        "width": 1.5,
        "height": 3.2
      }
    ]
  }
];

// Função helper para gerar comandos baseados no número do circuito
export const generateCommands = (circuitNumber) => {
  // Converte número para letra (1=A, 2=B, etc.)
  const letter = String.fromCharCode(64 + circuitNumber); // 65 é 'A' em ASCII
  return {
    onCommand: `1${letter}10`,
    offCommand: `1${letter}00`
  };
};

// Função para obter informações de comando para cada circuito
export const getCircuitCommands = (circuitNumber) => {
  const circuit = iluminacaoConfig.find(c => c.circleNumber === circuitNumber);
  if (!circuit) {
    return null;
  }
  
  return {
    descricao: circuit.descricao,
    onCommand: circuit.onCommand,
    offCommand: circuit.offCommand
  };
};

// Função para obter circuito pelo ID
export const getCircuitById = (id) => {
  return iluminacaoConfig.find(c => c.id === id);
};